import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
  gap: 1.75,
  width: "100%",
};

export const card: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  p: "14px 16px",
  display: "flex",
  alignItems: "center",
  gap: 1.5,
});

export const iconWrap =
  (softBg: string): SxProps<Theme> =>
  () => ({
    width: 36,
    height: 36,
    borderRadius: 1.25,
    bgcolor: softBg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  });

export const valueBlock: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
};

export const value: SxProps<Theme> = {
  fontWeight: 800,
  fontSize: "1.0625rem",
  lineHeight: 1.1,
};

export const label: SxProps<Theme> = {
  fontSize: "0.71875rem",
  color: "text.secondary",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};
